import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 2",
  viewBox: "0 0 66.36 52.07"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M42.78 27.97c12.5-.44 20.09-5.74 20.09-11.98 0-6.65-8.27-12.04-22.36-12.04h-2.02L42.64 0l-6.16.02-10.17 3.93h-16.2C4.42 3.96 1.26 5.35 0 8.07h33.28c9.18 0 15.34 1.39 15.34 7.72 0 6.82-7.41 8.15-15.34 8.15H18.33l13.25 14.23c11.21 11.81 21.73 13.91 34.78 13.91l-23.59-24.1Z",
      style: {"fill":"#dd052b"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "FV-logo"}) } }